module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/partnerUI/partner-orders/partner-orders.component.scss
// module id = ./src/app/partnerUI/partner-orders/partner-orders.component.scss
// module chunks = main